import styled from "styled-components";

import { FlexDiv } from "../../../../../components/Atoms";
import Avatar from "@/components/Molecules/Avatar";

export const DoctorList = styled(FlexDiv)`
  flex-wrap: wrap;
  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const DoctorAvatar = styled(Avatar)`
  flex: 0 0 50%;
  margin: 0;
  padding: 8px 32px 8px 0;
  flex-wrap: nowrap;
  align-items: flex-start;
  @media only screen and (max-width: 767px) {
    flex: 1;
    padding: 8px 0;
  }
`;
